/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ApprovalUserParams,
  AutocompleteParams,
  BaseResponseAuthorityResponse,
  BaseResponseAutocompleteResponse,
  BaseResponseBoolean,
  BaseResponseListUserSearchResponse,
  BaseResponsePageResponseUserDto,
  BaseResponseString,
  BaseResponseUserDayOffResponse,
  BaseResponseUserDetailResponse,
  BaseResponseUserJoinResponse,
  BaseResponseUserResponse,
  CheckEmailDuplicateParams,
  DeactivateUserByAdminParams,
  FindRegularMembersParams,
  GetDecisionManagersParams,
  GetUserDayOffParams,
  GetUserPageParams,
  SaveFcmTokenParams,
  SendTemporaryPasswordParams,
  UpdateUserManagementRequest,
  UpdateUserRequest,
  UserJoinRequest,
  VerifyPasswordRequest,
} from './data-contracts';
import {ContentType, HttpClient, RequestParams} from './http-client';

export class User<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 핸드폰 번호와 비밀번호를 수정하기 위한 API
   *
   * @tags User
   * @name UpdateUser
   * @summary 회원 정보 수정
   * @request PUT:/app/users/update
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  updateUser = async (data: UpdateUserRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/users/update`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 유저 관리 관리자 지정, 전결권자 지정, 권한 변경 및 정보 변경
   *
   * @tags User
   * @name UpdateUserManagementInfo
   * @summary 유저 관리정보 수정
   * @request PUT:/app/users/management
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  updateUserManagementInfo = async (data: UpdateUserManagementRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/users/management`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 관리자에 의한 유저 강제 탈퇴
   *
   * @tags User
   * @name DeactivateUserByAdmin
   * @summary 유저 강제 탈퇴
   * @request DELETE:/app/users/management
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  deactivateUserByAdmin = async (query: DeactivateUserByAdminParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/users/management`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 신규 회원가입을 진행합니다.
   *
   * @tags User
   * @name RegisterUser
   * @summary 유저 회원가입
   * @request POST:/app/users
   * @secure
   * @response `201` `BaseResponseUserJoinResponse` Created
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  registerUser = async (data: UserJoinRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseUserJoinResponse, void>({
      path: `/app/users`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 회원 가입승인과 동시에 권한을 부여하는 API
   *
   * @tags User
   * @name ApprovalUser
   * @summary 회원가입 승인
   * @request POST:/app/users/{userUuid}/approval-user
   * @secure
   * @response `200` `BaseResponseUserResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  approvalUser = async ({userUuid, ...query}: ApprovalUserParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseUserResponse, void>({
      path: `/app/users/${userUuid}/approval-user`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description MY INFORMATION 페이지 진입을 위해 비밀번호를 재입력하여 확인합니다.
   *
   * @tags User
   * @name VerifyPassword
   * @summary 비밀번호 확인
   * @request POST:/app/users/verify-password
   * @secure
   * @response `200` `BaseResponseBoolean` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  verifyPassword = async (data: VerifyPasswordRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseBoolean, void>({
      path: `/app/users/verify-password`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 비밀번호 분실 시 이메일로 임시 비밀번호를 발송합니다.
   *
   * @tags User
   * @name SendTemporaryPassword
   * @summary 임시 비밀번호 발송
   * @request POST:/app/users/temp-password
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  sendTemporaryPassword = async (query: SendTemporaryPasswordParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/users/temp-password`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 사용자의 FCM 토큰을 저장하고 중복된 토큰이 있으면 제거합니다.
   *
   * @tags User
   * @name SaveFcmToken
   * @summary FCM 토큰 저장
   * @request POST:/app/users/fcm-token
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  saveFcmToken = async (query: SaveFcmTokenParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/users/fcm-token`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 유저 관리 상세조회 페이지
   *
   * @tags User
   * @name GetUserByUuid
   * @summary 유저 관리정보 상세조회
   * @request GET:/app/users/{uuid}
   * @secure
   * @response `200` `BaseResponseUserResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getUserByUuidKey = (uuid: string) => ['app', 'users', uuid];

  getUserByUuid = async (uuid: string, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseUserResponse, void>({
      path: `/app/users/${uuid}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 유저를 페이지 형태로 조회합니다. (조건이 들어오면 조건 검색)
   *
   * @tags User
   * @name GetUserPage
   * @summary 유저 조회
   * @request GET:/app/users/search
   * @secure
   * @response `200` `BaseResponsePageResponseUserDto` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getUserPageKey = (query: GetUserPageParams) => ['app', 'users', 'search', query];

  getUserPage = async (query: GetUserPageParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponsePageResponseUserDto, void>({
      path: `/app/users/search`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 이름(name)과 부서(companyDepartment)로 정회원 목록을 검색합니다.
   *
   * @tags User
   * @name FindRegularMembers
   * @summary 정회원 조회 및 검색
   * @request GET:/app/users/members
   * @secure
   * @response `200` `BaseResponseListUserSearchResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  findRegularMembersKey = (query: FindRegularMembersParams) => ['app', 'users', 'members', query];

  findRegularMembers = async (query: FindRegularMembersParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseListUserSearchResponse, void>({
      path: `/app/users/members`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 내 회원가입 정보를 조회합니다. 서명 이미지는 정회원(Authority 연관 관계가 있는 사용자)만 반환됩니다. 정회원 여부를 함께 반환합니다.
   *
   * @tags User
   * @name GetUserDetail
   * @summary 내 회원가입 정보 조회
   * @request GET:/app/users/detail
   * @secure
   * @response `200` `BaseResponseUserDetailResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getUserDetailKey = () => ['app', 'users', 'detail'];

  getUserDetail = async (params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseUserDetailResponse, void>({
      path: `/app/users/detail`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 전결권자(결재 권한을 가진 사용자) 목록을 조회하거나 검색할 수 있습니다.
   *
   * @tags User
   * @name GetDecisionManagers
   * @summary 전결권자 조회 및 검색
   * @request GET:/app/users/decision-managers
   * @secure
   * @response `200` `BaseResponseListUserSearchResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getDecisionManagersKey = (query: GetDecisionManagersParams) => ['app', 'users', 'decision-managers', query];

  getDecisionManagers = async (query: GetDecisionManagersParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseListUserSearchResponse, void>({
      path: `/app/users/decision-managers`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 유저의 잔여 휴가를 조회합니다.
   *
   * @tags User
   * @name GetUserDayOff
   * @summary 잔여 휴가 조회
   * @request GET:/app/users/day-off
   * @secure
   * @response `200` `BaseResponseUserDayOffResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getUserDayOffKey = (query: GetUserDayOffParams) => ['app', 'users', 'day-off', query];

  getUserDayOff = async (query: GetUserDayOffParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseUserDayOffResponse, void>({
      path: `/app/users/day-off`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 이메일 중복 여부를 확인합니다.
   *
   * @tags User
   * @name CheckEmailDuplicate
   * @summary 이메일 중복 검사
   * @request GET:/app/users/check-email
   * @secure
   * @response `200` `BaseResponseBoolean` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  checkEmailDuplicateKey = (query: CheckEmailDuplicateParams) => ['app', 'users', 'check-email', query];

  checkEmailDuplicate = async (query: CheckEmailDuplicateParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseBoolean, void>({
      path: `/app/users/check-email`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 유저 페이지 검색창에 검색어를 입력하면 자동완성 제공
   *
   * @tags User
   * @name Autocomplete
   * @summary 유저 검색어 자동완성
   * @request GET:/app/users/autocomplete
   * @secure
   * @response `200` `BaseResponseAutocompleteResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  autocompleteKey = (query: AutocompleteParams) => ['app', 'users', 'autocomplete', query];

  autocomplete = async (query: AutocompleteParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseAutocompleteResponse, void>({
      path: `/app/users/autocomplete`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 유저의 권한 리스트를 노출 시킵니다.
   *
   * @tags User
   * @name GetAuthorities
   * @summary Authority 리스트
   * @request GET:/app/users/authorities
   * @secure
   * @response `200` `BaseResponseAuthorityResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getAuthoritiesKey = () => ['app', 'users', 'authorities'];

  getAuthorities = async (params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseAuthorityResponse, void>({
      path: `/app/users/authorities`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 비밀번호 재입력 후 회원 탈퇴를 진행합니다.
   *
   * @tags User
   * @name DeactivateUser
   * @summary 회원 탈퇴
   * @request DELETE:/app/users/delete
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  deactivateUser = async (data: VerifyPasswordRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/users/delete`,
      method: 'DELETE',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };
}
